import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      navigate("/login");
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div>
      <h1>Not Found Page</h1>
      <p>Redirecting to login in {countdown} seconds...</p>
    </div>
  );
}

export default NotFound;